// Restore the previous listing context when Liquid cannot render it directly.
// Collection context is resolved again in the current locale before insertion.

const prevUrl = localStorage.getItem('prevPage')
const prevPageHandle = localStorage.getItem('prevPageHandle')
const prevPageLocale = localStorage.getItem('prevPageLocale')
const prevPageTitle = localStorage.getItem('prevPageTitle')

const getLocalizedCollectionData = async (collectionHandle) => {
  const productCollectionData = document.querySelector(
    '.js-product-collection-breadcrumb-data'
  )
  const productCollectionLink = Array.from(
    productCollectionData?.content.querySelectorAll('[data-handle]') || []
  ).find((link) => link.dataset.handle === collectionHandle)

  if (productCollectionLink) {
    return {
      title: productCollectionLink.textContent.trim(),
      url: productCollectionLink.getAttribute('href'),
    }
  }

  if (!collectionHandle) return null

  const localeRoot = document.documentElement.dataset.localeRoot || ''
  const localizedCollectionUrl = new URL(
    `${localeRoot === '/' ? '' : localeRoot}/collections/${encodeURIComponent(collectionHandle)}`,
    window.location.origin
  )
  localizedCollectionUrl.searchParams.set('section_id', 'breadcrumbs')

  try {
    const response = await fetch(localizedCollectionUrl)
    if (!response.ok) return null

    const sectionDocument = new DOMParser().parseFromString(
      await response.text(),
      'text/html'
    )
    const localizedCollectionLink = sectionDocument
      .querySelector('.js-breadcrumb-collection-data')
      ?.content.querySelector('[data-handle]')

    if (localizedCollectionLink?.dataset.handle !== collectionHandle) return null

    return {
      title: localizedCollectionLink.textContent.trim(),
      url: localizedCollectionLink.getAttribute('href'),
    }
  } catch {
    return null
  }
}

const renderStoredBreadcrumb = async () => {
  if (!prevUrl) return

  const isReferrer = document.referrer.indexOf(prevUrl) > -1
  const isProduct = window.location.href.includes('products')
  const isBlogs = window.location.href.includes('blogs')
  const isPages = prevUrl.includes('pages')

  const breadcrumbTemplate = isBlogs
    ? 'blogs'
    : isPages
      ? 'pages'
      : 'collections'
  const urlBreadcrumb = document.querySelector('.js-collection-url-breadcrumb')
  const collectionBreadcrumbAlreadyOnPage = Boolean(urlBreadcrumb)
  const collectionBreadcrumb = document.querySelector(
    '.js-collection-breadcrumb'
  )
  const collectionHandle =
    prevPageHandle || prevUrl.split('/collections/')[1]?.split('/')[0]
  const localeRoot = document.documentElement.dataset.localeRoot || ''
  const previousPath = new URL(prevUrl, window.location.origin).pathname
  const isCurrentLocale = prevPageLocale
    ? prevPageLocale === document.documentElement.lang
    : !localeRoot ||
      localeRoot === '/' ||
      previousPath === localeRoot ||
      previousPath.startsWith(`${localeRoot}/`)
  const localizedCollection =
    breadcrumbTemplate === 'collections' && !isCurrentLocale
      ? await getLocalizedCollectionData(collectionHandle)
      : null
  const canRenderStoredBreadcrumb =
    breadcrumbTemplate !== 'collections' ||
    localizedCollection ||
    isCurrentLocale

  if (
    collectionBreadcrumb &&
    !collectionBreadcrumbAlreadyOnPage &&
    canRenderStoredBreadcrumb &&
    (isReferrer || isProduct)
  ) {
    const collectionLink = collectionBreadcrumb.querySelector('a')
    const fallbackLabel = prevUrl
      .replaceAll('-', ' ')
      .replaceAll(`${breadcrumbTemplate}`, '')
      .replaceAll('/', '')

    collectionLink.href = localizedCollection?.url || prevUrl
    collectionLink.innerText =
      localizedCollection?.title ||
      (breadcrumbTemplate === 'collections' && prevPageTitle
        ? prevPageTitle
        : fallbackLabel)
    collectionBreadcrumb.classList.remove('hidden')
  }

  // Retain prevPage localStorage when in product page changing variants
  if (!isProduct) {
    localStorage.removeItem('prevPage')
    localStorage.removeItem('prevPageHandle')
    localStorage.removeItem('prevPageLocale')
    localStorage.removeItem('prevPageTitle')
  }
}

renderStoredBreadcrumb()
